import React from 'react';

export function ClearableInput({
  type = 'text',
  value,
  onChange,
  placeholder,
}) {
  const hasValue = Boolean(value);

  return (
    <div className="clearable-input">
      <input
        type={type}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        className="clearable-input__field"
        style={{ paddingRight: hasValue ? 24 : undefined }}
      />
      {hasValue && (
        <button
          type="button"
          onClick={() => onChange({ target: { value: '' } })}
          className="clearable-input__button"
          aria-label="Clear filter"
          title="Clear filter"
        >
          x
        </button>
      )}
    </div>
  );
}

export function ClearableRangeInputs({
  type,
  from,
  to,
  onFromChange,
  onToChange,
  clearLabel = 'Clear',
}) {
  const hasValue = Boolean(from || to);

  return (
    <div className="clearable-range">
      <input
        type={type}
        value={from || ''}
        onChange={onFromChange}
        className="clearable-range__field"
      />
      <input
        type={type}
        value={to || ''}
        onChange={onToChange}
        className="clearable-range__field"
      />
      {hasValue && (
        <button
          type="button"
          onClick={() => {
            onFromChange({ target: { value: '' } });
            onToChange({ target: { value: '' } });
          }}
          className="clearable-range__button"
        >
          {clearLabel}
        </button>
      )}
    </div>
  );
}

export function FilterToolbar({
  chips,
  onRemoveChip,
  onClearAll,
  showClearButton = true,
}) {
  return (
    <div className="filter-toolbar">
      {showClearButton && (
        <button
          type="button"
          onClick={onClearAll}
          disabled={chips.length === 0}
          className="filter-toolbar__clear"
        >
          Clear All Filters
        </button>
      )}
      <div className="filter-toolbar__chips">
        {chips.map(chip => (
          <span key={chip.key} className="filter-chip">
            <span className="filter-chip__label">{chip.label}</span>
            <button
              type="button"
              onClick={() => onRemoveChip(chip.key)}
              className="filter-chip__remove"
              aria-label={`Remove ${chip.label}`}
              title="Remove filter"
            >
              x
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}
